<!-- 项目文件 -->
<template>
    <div class="posre w100p" @click="onClose">

        <Header :Logo="logo" :newYm="newYm" :iscity1="City1" @childFn="parentFn" :city="City" :Link="link" :TitleList="titleList" :Color="color" ></Header>
        <HeaderBanner></HeaderBanner>
        
        <div class="posab top90  w100p" v-show="open">
            <div class="w1200 mauto overflow-y h500 bgf4 overhidden posre zindex999" @click.stop="onOpen()">
                <div class="pl25 cursor fs14 c333 pt5 pb15" @click.stop="onOpenC()">当前定位 {{gpsCity}} </div>
                <div class="w100p fs0 alit floatl posre  app-download" v-for="(item,index) in cityList" :key="index">
                    <span class="floatl disinblock textc mt5 mb5 w15p fs22"> {{item.lettertop}} </span>
                    <ul class="disinblock floatr w85p textl mt5 mb5 h100p  right0 ">
                        <li class="fs14 c333  floatl disinblock" v-for="(v,i) in item.city" :key="i">
                            <span class="disinblock cursor ml5 mr5" @click.stop="upCity(v.name,v.area_id)"> {{v.name}}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="w100p">
            <div class="w100p pt40 ">
                <div class="w1200 mauto">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                口碑驾校
                            </span>
                        </p>

                    </div>
                    <div class="w100p">
                        <ul class=" ml-16 p0 overhidden pb10">
                            <li class="w18p fs0 ml20 box bradius8 box-shadow2 mt10  disinblock floatl "
                                v-for="(item,index) in schoolList" :key="index">
                                <img class="w100p h168 brt8"
                                    :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png' "
                                    alt="">
                                <div class="overhidden pt8 pl12 pr12 pb8 fs0">
                                    <span class="alit"><span class=" fs16 fbold c333 pt2 pb2 over_1"> {{item.school_name}} </span>
                                        <span class="ml4 disflex">
                                            <img class="w16 h16 mr2" :src="v.medal_img" alt="" v-for="(v,i) in item.medals" :key="i">
                                        </span>
                                    </span>
                                    <span class="disblock fs14 c666 pt2 pb2  over_1"> {{item.school_address}} </span>
                                    <span class="pt4 pb4 fs0 disblock" v-if="item.star">
                                        <img v-if="item.star!=0" v-for="(v,i) in parseInt(item.star)" :key="i" class="w16 h16 mr6"
                                            src="../../public/img/img80_1.png" alt="">
                                        <img v-if="parseInt(item.star) != item.star" class="w16 h16 mr6" src="../../public/img/img80_3.png" alt="">
                                        <img v-if="item.star < 4.1" v-for="(vv,ii) in 5-Math.ceil(item.star)" class="w16 h16 mr6"
                                            src="../../public/img/img80_2.png" alt="">
                                        <i class="cff8 fs12">
                                            {{item.star ||'暂无评分'}}
                                        </i>
                                    </span>
                                    
                                    <span class='pt4 pb4 fs0 disblock'>
                                        <span class="fs14 c999 ">共 {{item.comment_count || '0'}} 条评论</span>
                                        <img v-for="(v,i) in item.hotImages" v-if="item.hotImages" class="w12 h12 ml10" :src="v" alt="">
                                    </span>


                                    <span class="disblock overhidden posre pb2">
                                        <span class=" cff0 fs14 floatl posab h100p alit">¥<i class="fs16 cff0">
                                                {{item.min_price}} </i></span>
                                        <span @click="toSchooldetail(item.school_id)"
                                            class="floatr disblock fs14 bg1f8 pl14 pr14 pt5 pb5 bradius20 cfff cursor">立即报名</span>
                                    </span>

                                </div>
                            </li>
                        </ul>

                        <div class="textc mt20 mb20">
                            <span @click="Toreschool()"
                                class="cursor disinblock fs18 bradius8 border1f8 c1f8 pt10 pb10 pl45 pr45">查看更多>></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w100p"  id="xuexi"> 
            <div class="w100p pt40">
                <div class="w1200 mauto">
                    <div class="textc mt20 mb20">
                        <p class="fs36 c333 disinblock posre">
                            <span class="border-bottom1">
                                理论学习
                            </span>
                        </p>
                    </div>
                    <div class="w100p overhidden pt20">
                        <div class="w48p pb20 disinblock floatl bgf5">
                            <div class="pt10 pb10 textc">
                                <p class="pt12"><img class="w40 h30" src="../../public/img/img57.png"></p>
                                <p class="pt12 pb10 fs18 c333 fbold">科目一交规</p>
                                <p class="fs14 c999">真实还原交管局难度</p>
                            </div>
                            <div class="ml38 mr38 overhidden">
                                <p class="overflow mb5">
                                    <span  @click="Tosub2(0)" class="cursor floatl disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                        <img class="w58 h58 hauto cursor " src="../../public/img/img59.png">
                                        <span class="disinblock floatr w70p pl10">
                                            <span class="disblock fs16 fbold pb3">顺序练习</span>
                                            <span class="disblock fs14 c999 pt3">按照顺序练习做题</span>
                                        </span>
                                    </span>
                                    <span @click="Tosub4(0)" class="cursor floatr disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                        <img class="w58 h58 hauto cursor " src="../../public/img/img60.png" >
                                        <span class="disinblock floatr w70p pl10">
                                            <span class="disblock fs16 fbold pb3">随机练习</span>
                                            <span class="disblock fs14 c999 pt3">所有法规一个不漏</span>
                                        </span>
                                    </span>
                               
                                </p>
                                <p class="overflow mt5">

                                    <span @click="toChap1(1)" class="cursor floatl disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                        <img class="w58 h58 hauto cursor " src="../../public/img/img61.png">
                                        <span class="disinblock floatr w70p pl10">
                                            <span class="disblock fs16 fbold pb3">专项练习</span>
                                            <span class="disblock fs14 c999 pt3">分门别类重点突破</span>
                                        </span>
                                    </span>
                                    <router-link to="Skill">
                                        <span class="cursor floatr disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                            <img class="w58 h58 hauto cursor " src="../../public/img/img62.png">
                                            <span class="disinblock floatr w70p pl10">
                                                <span class="disblock fs16 fbold pb3">考试技巧</span>
                                                <span class="disblock fs14 c999 pt3">准确把握考试难点</span>
                                            </span>
                                    
                                        </span>
                                    </router-link>
                                </p>
                            </div>
                            <p class="textc mt15 mb20">
                                <span @click="Tomoni1()"
                                    class="cfff cursor bg1f8 bradius5 fs16 disinblock fbold  pt10 pb10 w50p">模拟考试</span>
                            </p>
                        </div>
                        <div class="w48p pb20 disinblock floatr bgf5">
                            <div class="pt10 pb10 textc">
                                <p class="pt12 "><img class="w30 h30" src="../../public/img/img58.png"></p>
                                <p class="pt12 pb10 fs18 c333 fbold">科目四安全文明驾驶</p>
                                <p class="fs14 c999">真实还原交管局难度</p>
                            </div>
                            <div class="ml38 mr38 overhidden">
                                <p class="overflow mb5">
                                    <span @click="Tosub3(0)" class="cursor floatl disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                        <img class="w58 h58 hauto cursor " src="../../public/img/img59.png">
                                        <span class="disinblock floatr w70p pl10">
                                            <span class="disblock fs16 fbold pb3">顺序练习</span>
                                            <span class="disblock fs14 c999 pt3">按照顺序练习做题</span>
                                        </span>
                                    </span>
                                    <span @click="Tosub5(0)" class="cursor floatr disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                        <img class="w58 h58 hauto cursor " src="../../public/img/img60.png">
                                        <span class="disinblock floatr w70p pl10">
                                            <span class="disblock fs16 fbold pb3">随机练习</span>
                                            <span class="disblock fs14 c999 pt3">所有法规一个不漏</span>
                                        </span>
                                    </span>
                        
                                </p>
                                <p class="overflow mt5">

                                    <span  @click="toChap4(5)" class="cursor floatl disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                        <img class="w58 h58 hauto cursor " src="../../public/img/img61.png">
                                        <span class="disinblock floatr w70p pl10">
                                            <span class="disblock fs16 fbold pb3">专项练习</span>
                                            <span class="disblock fs14 c999 pt3">分门别类重点突破</span>
                                        </span>
                                    </span>
                                    <router-link to="Skill">
                                        <span class="cursor floatr disblock w44p  mt5 mb5 bgfff overflow pl10 pr10 pt10 pb10 alit">
                                            <img class="w58 h58 hauto cursor " src="../../public/img/img62.png">
                                            <span class="disinblock floatr w70p pl10">
                                                <span class="disblock fs16 fbold pb3">考试技巧</span>
                                                <span class="disblock fs14 c999 pt3">准确把握考试难点</span>
                                            </span>
                                    
                                        </span>
                                    </router-link>
                                </p>
                            </div>
                            <p class="textc mt15 mb20">
                                <span @click="Tomoni4()"
                                    class="cfff cursor bg1f8 bradius5 fs16 disinblock fbold  pt10 pb10 w50p">模拟考试</span>
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="w100p mt30">
            <div class="w1200 pb20 pl10 pr10 pt20 mauto overhidden">
                <div class="w65p bradius8 minh480 pl20  pr20 disinblock floatl box-shadow2">
                    <div class="pt20 pb20">
                        <ul class="disinblock hauto">
                            <li @mouseenter="activeIndex(0)" :class="{'active1':index==0}"
                                class="ml10 mr10 disinblock floatl bge8f pl20 pr20 br20 pt10 pb10 fs16 c1f8 cursor">
                                顺序练习
                            </li>
                            <li @mouseenter="activeIndex(1)" :class="{'active1':index==1}"
                                class="ml10 mr10 disinblock floatl bge8f pl20 pr20 br20 pt10 pb10 fs16 c1f8 cursor">
                                随机练习
                            </li>
                            <li @mouseenter="activeIndex(2)" :class="{'active1':index==2}"
                                class="ml10 mr10 disinblock floatl bge8f pl20 pr20 br20 pt10 pb10 fs16 c1f8 cursor">
                                专项练习
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div class="icon-plus" v-show="index == 0">
                            <div class="floatl w50p disinblock">
                                <p class="fs16 c333  pb16 fbold">2020年小车科目一顺序练习试题</p>
                                <ul>
                                    <li @click="Tosub2(index)" class="mt8 mb8 alit lh26"
                                        v-for="(item,index) in orderList.OneList.slice(0,10)" :key="index">
                                        <i class="c1f8"> ● </i>
                                        <span class="hov ml6 c333 fs14 cursor over_1 w80p disinblock"> {{item.title}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="floatr w50p disinblock">
                                <p class="fs16 c333  pb16 fbold">2020年小车科目四顺序练习试题</p>
                                <ul>
                                    <li @click="Tosub3(index)" class="mt8 mb8 alit lh26"
                                        v-for="(item,index) in orderList.FourList.slice(0,10)" :key="index">
                                        <i class="c1f8"> ● </i>
                                        <span class="hov ml6 c333 fs14 cursor over_1 w80p disinblock"> {{item.title}}
                                        </span>
                                    </li>

                                </ul>
                            </div>
                            
                            <loading v-if="isLoading"></loading>
                           
                        </div>

                        <div class="icon-plus" v-show="index == 1">
                            <div class="floatl w50p disinblock">
                                <p class="fs16 c333  pb16 fbold">2020年小车科目一随机练习试题</p>
                                <ul>
                                    <li @click="Tosub4(item.exercise_id)" class="mt8 mb8 alit lh26"
                                        v-for="(item,index) in unorderList.OneList.slice(0,10)" :key="index">
                                        <i class="c1f8"> ● </i>
                                        <span class="hov ml6 c333 fs14 cursor over_1 w80p disinblock"> {{item.title}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="floatr w50p disinblock">
                                <p class="fs16 c333  pb16 fbold">2020年小车科目四随机练习试题</p>
                                <ul>
                                    <li @click="Tosub5(index)" class="mt8 mb8 alit lh26"
                                        v-for="(item,index) in unorderList.FourList.slice(0,10)" :key="index">
                                        <i class="c1f8"> ● </i>
                                        <span class="hov ml6 c333 fs14 cursor over_1 w80p disinblock"> {{item.title}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="icon-plus" v-show="index == 2">
                            <div class="floatl w50p disinblock">
                                <p class="fs16 c333  pb16 fbold">2020年小车科目一专项练习试题</p>
                                <ul>
                                    <li @click="toChap1(item.id)" class="mt8 mb8 alit lh26" v-for="(item,index) in OneChapList"
                                        :key="index">
                                        <i class="c1f8"> ● </i>
                                        <span class="hov ml6 c333 fs14 cursor over_1 w80p disinblock"> {{item.chapter_name}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                            <div class="floatr w50p disinblock">
                                <p class="fs16 c333  pb16 fbold">2020年小车科目四专项练习试题</p>
                                <ul>
                                    <li @click="toChap4(item.id)" class="mt8 mb8 alit lh26" v-for="(item,index) in FourChapList"
                                        :key="index">
                                        <i class="c1f8"> ● </i>
                                        <span class="hov ml6 c333 fs14 cursor over_1 w80p disinblock"> {{item.chapter_name}}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="w25p bradius8 minh480  pl20 pr20 disinblock floatr box-shadow2 posre">
                    <p class="fs16 c333 pt16  pb16 fbold">2020年小车科目一试题</p>
                    <div class="pt10 pb10">
                        <p class="fs16 c333">
                            {{practice.exercise_id}}、
                            {{practice.title}}
                        </p>
                        <span @click="TosubDetail(practice.exercise_id-1)"
                            class="cursor c999 fs14 floatr pt5">?查看本题分析</span>
                        <div class="fs14 c333 mt20">
                            <p :class="{'aaaaa':once==1}" v-for="(item,index) in choose_listX" :key="index"
                                @click="choose(item.chose,practice.answer,$event,practice.exercise_id,practice,index)"
                                class="cursor alit mt15 mb15 borther answerParent" ref="answerParent">
                                <!-- <img class="w22 h22 answerImg" :src="answerImg" alt="" ref="answerImg"> -->

                                <img v-if="item.T==0" class="w22 h22" src="../../public/img/img68.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==1" class="w22 h22" src="../../public/img/img67.png" alt=""
                                    ref="answerImg">
                                <img v-if="item.T==2" class="w22 h22" src="../../public/img/img69.png" alt=""
                                    ref="answerImg">
                                <span class="disinblock ml16"> {{item.chose}} </span>
                            </p>
                        </div>
                        <div v-show="practice.image" class="pl16 pr16 pt8 pb8">
                            <img class="w100p hauto bradius8 maxh135" :src="practice.image " alt="">
                        </div>
                        <div class="pt8 pb8 posab left0 w100p bottom10">
                            <p class="overhidden w70p mauto">
                                <span @click="last()"
                                    class="border2e bradius25 fs14 c666 c333 bgfff  floatl pl20 pr20 pt8 pb8 cursor">上一题</span>
                                <span @click="next()"
                                    class=" bradius25 fs14 disinblock floatr pl20 pr20 pt8 pb8 c1f8 bge8f cursor">下一题</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Banner :cityID="cityIDD" :news="newsList" :banner="newsBanner"></Banner>
        <Video ></Video>
        <Guidebook></Guidebook>
        <Footer :newYm="newYm"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import HeaderBanner from '@/components/Headerbanner'
    import Footer from '@/components/Footer'
    import Banner from '@/components/Banner'
    import Video from '@/components/Video'
    import loading from '@/components/Loading'
    import Guidebook from '@/components/Guidebook'
    import $axios from "axios";
    import $ from "jquery";
    export default {
        data() {
            return {
                newYm: 1,
                color: 1,
                City: '',
                City1: 1,
                Lng: '',
                Lat: '',
                link: 2,
                titleList: 4,
                logo: 'home',

                open: false,
                Provinces: '',
                chooseCity: '',
                cityList: [],
                gpsCity: '',
                cityIDD: '',
                cityIDD2: '',
                schoolList: [],
                index: 0,
                orderList: { //有序
                    OneList: [], //科目1
                    FourList: [], //科目4
                },
                unorderList: { //随机
                    OneList: [],
                    FourList: [],
                },

                practice: { //练习题
                    title: '',
                    answer: '', //正确答案
                    image: '',
                    title: '',
                    exercise_id: '', //题号
                },
                choose_listX: [], //选项
                practiceList: [],
                chooseList: [],
                typeIndex: 0,
                answerImg: require('../../public/img/img68.png'),
                once: 0,
                Already: [],
                newsList: [], //新闻资讯
                newsBanner: [], //新闻轮播
                OneChapList: [],
                FourChapList: [],
                isLoading: true,
                sort_type: 2
            };
        },
        components: {
            Header,
            Footer,
            Banner,
            Video,
            Guidebook,
            loading,
            HeaderBanner
        },
        methods: {
            getCityP() {
                var that = this;
                var map = new BMap.Map("container");
                var nowCity = new BMap.LocalCity();
                nowCity.get(bdGetPosition);

                function bdGetPosition(result) {
                    that.gpsCity = result.name;
                    if (that.$store.state.cityName != "") {
                        that.City = that.$store.state.cityName;
                    } else {
                        that.City = result.name;
                    }
                    that.$forceUpdate()
                    that.$store.dispatch('cityment').then(() => {
                        that.$store.state.cityName = that.City;
                    });

                    that.Lng = result.center.lng;
                    that.Lat = result.center.lat;
                    that.getCitys();

                }

            },
            activeIndex(id) { //滑动
                this.index = id;
                if (id == 0) {
                    console.log(this.orderList)
                } else if (id == 2) {
                    if (this.OneChapList.length == 0) {

                    }

                }
                // this.getOne();
                // this.getFour()
            },

            getSchool(cityId, a) {
                let that = this;
                if (a == 1 && that.$store.state.cityIDX.name != "") {
                    cityId = that.$store.state.cityIDX.name;
                }
                that.schoolList = [];
                let cityName = that.$store.state.cityName;
                $axios.get('/school/getSchoolList.do', {
                    params: {
                        area_id: cityId,
                        sort_type: that.sort_type,
                        lat: that.Lat,
                        lng: that.Lng,
                        page: 1
                    }
                }).then(function(res) {
                    that.schoolList = res.data.obj;

                }).catch(function(error) {
                    console.log(error);
                });
            },

            parentFn(childData) {
                this.open = childData;
            },
            onOpen() {
                this.open = true;
            },
            onOpenC() {
                let that = this;
                this.open = false;
                that.$forceUpdate()
                that.$store.dispatch('cityment').then(() => {
                    that.$store.state.cityName = that.gpsCity;
                });
                that.$store.dispatch('cityidment').then(() => {

                    that.$store.state.cityIDX.name = that.cityIDD2;
                });
                this.City = this.gpsCity;

                // that.sort_type = 2
                that.getSchool(that.cityIDD2)
                    // if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                    //     that.sort_type = 3
                    //     that.getSchool(that.cityIDD2);
                    //     if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                    //         that.sort_type = 1
                    //         that.getSchool(that.cityIDD2)
                    //     }
                    // }

            },
            onClose(event) {
                let that = this;
                var btn = document.querySelector(".app-download");
                if (btn) {
                    if (!btn.contains(event.target)) { //按钮.app-download以外的区域
                        that.open = false;
                    } else {
                        that.open = true
                    }
                }
            },
            upCity(name, id) {
                console.log(id)
                let that = this;
                that.$forceUpdate()
                that.$store.dispatch('cityment').then(() => {
                    that.$store.state.cityName = name;
                });

                that.$store.dispatch('cityidment').then(() => {
                    that.$store.state.cityIDX.name = id;
                });
                that.getNews(id)
                that.City = name;
                that.open = false;

                that.cityIDD = id;
                //that.sort_type = 2;
                that.getSchool(id);
                // if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                //     that.sort_type = 3;
                //     that.getSchool(id);
                //     if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                //         that.sort_type = 1
                //         that.getSchool(id);
                //     }
                // }
            },
            getCitys() {
                let that = this;
                let cityhead = [];
                let newcityhead = [];
                $axios.get('/school/getCitys.do').then(function(res) {
                    let cityListX = res.data.obj;
                    for (let i = 0; i < cityListX.length; i++) {
                        let letterx = cityListX[i].py.charAt(0).toUpperCase(); //toUpperCase() 方法用于把字符串转换为大写
                        cityhead.push(letterx);
                    }
                    for (let i = 0; i < cityhead.length; i++) {
                        if (newcityhead.indexOf(cityhead[i]) == -1) {
                            newcityhead.push(cityhead[i]);
                        }
                    }
                    newcityhead = newcityhead.sort(function compareFunction(item1, item2) {
                        return item1.localeCompare(item2);
                    });
                    for (let i = 0; i < newcityhead.length; i++) {
                        let obj = new Object();
                        //为对象添加动态属性
                        obj.lettertop = newcityhead[i];
                        obj.city = [];
                        for (let j = 0; j < cityListX.length; j++) {
                            if (newcityhead[i].toUpperCase() == cityListX[j].py.charAt(0)) {
                                obj.city.push(cityListX[j]);
                                if (that.gpsCity == cityListX[j].name) {
                                    let Id = cityListX[j].area_id;
                                    that.cityIDD = Id;
                                    that.cityIDD2 = Id;
                                    that.getNews(Id);
                                    if (that.$store.state.cityIDX.name == '') {
                                        console.log(Id)
                                        that.$forceUpdate()
                                        that.$store.dispatch('cityidment').then(() => {
                                            that.$store.state.cityIDX.name = Id;
                                        });

                                        //that.$store.commit('cityidment', Id)
                                    }
                                    // that.sort_type = 2;
                                    that.getSchool(Id, 1);

                                    // if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                                    //     that.sort_type = 3
                                    //     that.getSchool(Id, 1);
                                    //     if (that.schoolList == '' || that.schoolList == undefined || that.schoolList.length == 0) {
                                    //         that.sort_type = 1
                                    //         that.getSchool(Id, 1);
                                    //     }
                                    // }

                                    // return;
                                }
                            }
                        }
                        that.cityList.push(obj);
                    }

                }).catch(function(error) {
                    console.log(error);
                });
            },
            getOne() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 1,
                        "order": that.index
                    },
                    success: function(data) {


                        if (that.index == 1) {
                            that.isLoading = false;
                            that.unorderList.OneList = data.obj;
                        }

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            getFour() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 4,
                        "order": that.index
                    },
                    success: function(data) {
                        if (that.index == 0) {
                            that.orderList.FourList = data.obj;
                        } else if (that.index == 1) {
                            that.unorderList.FourList = data.obj;
                        }
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            getOneChap() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getChapters.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 1,
                    },
                    success: function(data) {
                        that.OneChapList = data.obj
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            getFourChap() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getChapters.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 4,
                    },
                    success: function(data) {
                        that.FourChapList = data.obj;
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            getPractice() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/getSubjects.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "km_type": 1,
                        "order": that.index
                    },
                    success: function(data) {
                        that.orderList.OneList = data.obj;
                        let typeIndex = that.typeIndex;
                        that.practice = data.obj[typeIndex];
                        that.practiceList = data.obj;
                        that.practice.image = data.obj[typeIndex].image;
                        that.practice.answer = data.obj[typeIndex].answer;
                        let arr2 = data.obj[typeIndex].choose_list.split("|");
                        for (let i = 0; i < arr2.length; i++) {
                            let P = {
                                chose: arr2[i],
                                T: 0
                            }
                            that.choose_listX.push(P);

                        }

                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },


            next() {
                let that = this;
                if (that.practiceList.length != that.typeIndex + 1) {
                    that.typeIndex++;
                    that.Judgment();
                } else {
                    alert('这已经是最后一题了')
                }

            },
            last() {
                let that = this;
                if (that.typeIndex == 0) {
                    alert('这已经是第一题了')
                } else {
                    that.typeIndex--;
                    that.Judgment();
                }
            },
            Judgment() {

                let that = this;
                let aa = that.$refs.answerImg;

                this.practice = this.practiceList[this.typeIndex];
                let getAlready = that.$store.state.chooseList;

                let arr2 = that.practice.choose_list.split("|");
                that.choose_listX = []
                that.markList = []
                let markX = {
                    item: '',
                    index: '',
                    index1: '',
                    answer: '',
                    answerFR: -1,

                };
                for (let i = 0; i < arr2.length; i++) {
                    let P = {
                        chose: arr2[i],
                        T: 0
                    }
                    that.choose_listX.push(P)
                    that.markList.push(markX)
                }
                for (let i = 0; i < getAlready.length; i++) {
                    if (getAlready[i].index == that.practice.exercise_id) { //getAlready[i].index做了的题
                        if (getAlready[i].rigthFalse == true) {
                            that.once = 1;
                            console.log('对');
                            //item我选的那道题选项
                            //index1我选的那道题下标
                            console.log(that.choose_listX)

                            let P = {
                                chose: that.choose_listX[getAlready[i].index1].chose,
                                T: 1
                            }
                            that.choose_listX.splice(getAlready[i].index1, 1, P)
                        } else {
                            let j = getAlready[i].index1;
                            console.log('错误');
                            //循环选项
                            let itemX = that.practice.choose_list;

                            let P = {
                                chose: that.choose_listX[j].chose,
                                T: 2
                            }
                            that.choose_listX.splice(j, 1, P)
                            console.log('232322222222');
                            console.log(itemX);
                            for (let jj = 0; jj < arr2.length; jj++) {
                                // console.log(getAlready[i]);
                                if (arr2[jj].indexOf(getAlready[i].answer) != -1) {
                                    let P = {
                                        chose: that.choose_listX[jj].chose,
                                        T: 1
                                    }
                                    that.choose_listX.splice(jj, 1, P)
                                        //that.$refs.answerImg[jj].src = require('../../public/img/img67.png');
                                }
                            }
                            console.log('3333333333');
                            that.T = 2;
                            //that.$refs.answerImg[j].src = require('../../public/img/img69.png');
                        }
                        that.once = 1;
                        return;
                    } else {
                        that.once = 0;
                    }
                }
                if (that.once == 0) {
                    let mark1 = {
                        item: '',
                        index: '',
                        index1: '',
                        rigthFalse: '',
                        answer: ''
                    };
                    if (that.typeIndex == getAlready.length) {
                        // that.Already.splice(index - 1, 1, mark)
                        that.Already.push(mark1)
                    }
                    that.$forceUpdate()
                    that.$store.dispatch('asyncInrement').then(() => {
                        that.$store.state.chooseList = that.Already;
                    });
                }
            },
            forKemu() {
                for (let i = 0; i < 3; i++) {
                    this.index = i;
                    this.getOne();
                    this.getFour();
                }
                this.index = 0;

            },
            choose(item, answer, e, index, practice, index1) {
                let that = this;
                let rigth = '';
                that.once = 1;

                if (item.indexOf(answer) != -1) {
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 1
                    }
                    that.choose_listX.splice(index1, 1, P)
                        //e.currentTarget.firstElementChild.src = require('../../public/img/img67.png');
                    rigth = true;
                } else {
                    //e.currentTarget.firstElementChild.src = require('../../public/img/img69.png');
                    let P = {
                        chose: that.choose_listX[index1].chose,
                        T: 2
                    }
                    that.choose_listX.splice(index1, 1, P)
                    for (let i = 0; i < that.choose_listX.length; i++) {
                        if (that.choose_listX[i].chose.indexOf(answer) != -1) {
                            let P = {
                                chose: that.choose_listX[i].chose,
                                T: 1
                            }
                            that.choose_listX.splice(i, 1, P)
                        }
                    }
                    rigth = false;
                }
                let mark = {
                    item: item,
                    index: index,
                    index1: index1,
                    rigthFalse: rigth,
                    answer: answer,
                };
                let getAlready = that.$store.state.chooseList; //取vuex缓存'
                if (getAlready.length == 0) {
                    that.Already.push(mark)
                } else {
                    that.Already.splice(index - 1, 1, mark)
                }
                //console.log(getAlready)
                // that.Already.push(mark)

                that.$forceUpdate()
                that.$store.dispatch('asyncInrement').then(() => {
                    that.$store.state.chooseList = that.Already;
                });


            },
            getNews(cityid) {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: that.beseAjax + "/find/getFindList.do",
                    dataType: "json",
                    async: false,
                    data: {
                        "area_id": cityid,
                        "page": 1
                    },
                    success: function(data) {
                        that.newsList = data.obj;

                        for (let i = 0; i < that.newsList.length; i++) {
                            var strValue = that.newsList[i].content;
                            var re = new RegExp('<[^<>]+>', 'g');
                            var text1 = strValue.replace(re, "");
                            var text1 = text1.substring(0, 80);
                            that.$set(that.newsList[i], "text1", text1);
                        }

                        that.$forceUpdate()
                        that.$store.dispatch('newsment').then(() => {
                            that.$store.state.newsDetail = that.newsList;
                        });
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
            getBanner() {
                let that = this;
                $axios.post('/find/getBannerList.do').then(function(res) {
                    that.newsBanner = res.data.obj;

                }).catch(function(error) {
                    console.log(error);
                });
            },
            Toreschool() {
                let that = this;
                if (that.$store.state.cityIDX.name != "") {
                    that.cityIDD = that.$store.state.cityIDX.name;
                }
                this.$router.push({
                    path: "/Reschool",
                    query: {
                        cityid: that.cityIDD
                    }
                });
                //window.open(Toreschool.href, '_blank');
            },
            toSchooldetail(id) {
                this.$router.push({
                    path: `/Schooldetail`,
                    query: {
                        schoolId: id,
                        cityid: this.cityIDD2
                    }
                })
            },
            TosubDetail(index) {
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail",
                    query: {
                        tiku: index,
                    }
                });
                //window.open(TosubDetail.href, '_blank');
            },
            Tosub2(index) { //科一顺序
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail2",
                    query: {
                        tiku: index,
                        subject: 1,
                        obj: 'shunxu'
                    }
                });
                //window.open(Tosub2.href, '_blank');
            },
            Tosub4(index) { //科一顺序
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail2",
                    query: {
                        tiku: index,
                        subject: 1,
                        obj: 'suiji'
                    }
                });
                // window.open(Tosub4.href, '_blank');
            },
            toChap1(id) { //专项科目1
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail4",
                    query: {
                        chapter: id,
                    }
                });
                //window.open(toChap1.href, '_blank');
            },
            toChap4(id) { //专项科目1
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail6",
                    query: {
                        chapter: id,
                    }
                });
                //window.open(toChap4.href, '_blank');
            },
            Tosub3(index) { //科四顺序
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail3",
                    query: {
                        tiku: index,
                    }
                });
                // window.open(Tosub3.href, '_blank');
            },
            Tosub5(index) { //科四随机
                let that = this;
                this.$router.push({
                    path: "/SubjectDetail5",
                    query: {
                        tiku: index,
                    }
                });
                // window.open(Tosub5.href, '_blank');
            },
            Tomoni1() { //模拟1
                let that = this;
                this.$router.push({
                    path: "/Moni1",
                    query: {

                    }
                });
                //  window.open(Tomoni1.href, '_blank');
            },
            Tomoni4() { //模拟4
                let that = this;
                this.$router.push({
                    path: "/Moni4",
                    query: {

                    }
                });
                // window.open(Tomoni4.href, '_blank');
            },

        },


        created() {

            this.getCityP();
            this.getBanner();
            // this.forKemu();
            this.getPractice();
            this.Judgment();

            setTimeout(this.forKemu, 500);
            // setTimeout(this.forgetPracticeKemu, 1000);
            // setTimeout(this.Judgment, 1000);
            setTimeout(this.getOneChap, 500);
            setTimeout(this.getFourChap, 500);

        },

        mounted() {
            let that = this;
            if (window.performance.navigation.type == 1) {
                console.log("页面被刷新")

                that.Already = that.$store.state.chooseList;
                that.$forceUpdate()
                that.$store.dispatch('asyncInrement3').then(() => {
                    that.$store.state.chooseList = that.Already;
                });
            } else {
                var hash = window.location.hash;
                var index = hash.lastIndexOf("#");
                var studytype = that.$route.query.studytype;
                if (index != -1 && studytype == 1) {
                    var id = hash.substring(index + 1, hash.length + 1);
                    var div = document.getElementById('xuexi');
                    if (div) {
                        setTimeout(function() {
                            console.log($(div).offset().top);
                            //$('html,body').scrollTop($(div).offset().top - 43);
                            $('html, body').animate({
                                scrollTop: $(div).offset().top - 43
                            }, 100)
                        }, 100);
                    }
                }
            }


        }
    }
</script>
<style scoped>
    .active1 {
        background-color: #1f82f6;
        color: #fff;
    }
    
    .aaaaa {
        pointer-events: none;
    }
</style>